import { SiteModuleEnum } from '../../../../core/enum/site-module';
import templateUrl from './unclaimed-work-orders-list-container.component.html';
import { Booked } from '../../../../core/enum/product-order-status-type';

export const UnclaimedWorkOrdersListContainerComponent = {
    controller: UnclaimedWorkOrdersListContainerController,
    controllerAs: "vm",
    templateUrl
};

function UnclaimedWorkOrdersListContainerController($q, icdOfficeService, workOrderService, utilityService) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    const LEADS_MODULE = SiteModuleEnum.Leads;
    vm.$onInit = onInit;

    vm.icdOffices;
    vm.workOrders;
    vm.onClaimWorkOrder = onClaimWorkOrder;
    vm.onChangeIcdOffice = onChangeIcdOffice;
    vm.pageIndex = 1;
    vm.pageSize = 10;
    vm.dropdownOptions = {
        dataSource: new kendo.data.DataSource({
            data: vm.icdOffices,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#icd-offices-list").data("kendoDropDownList");
                const source = vm.icdOffices;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.Inactive !== true)
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }

    function onInit() {
        const workOrdersLoaded = loadWorkOrders();
        const icdOfficesLoaded = loadIcdOffices();

        icdOfficesLoaded.then(function () {
            if (vm.icdOffices.length === 1) {
                vm.icdOffice = vm.icdOffices[0];
            }
            return loadWorkOrders();
        }).then(function () {
            vm.workOrders.forEach(function (workOrder) {
                workOrder.IcdOffice = vm.icdOffices.filter(function (office) {
                    return office.Id === workOrder.IcdOfficeID;
                })[0];
            });
        })

        // Load the ICD office data into the work order.
        const workOrderIcdOfficesSet = $q.all([workOrdersLoaded, icdOfficesLoaded])
            .then(loadWorkOrderOffice);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(workOrderIcdOfficesSet, "Initial load failed"));
    }

    function onChangeIcdOffice() {
        const refreshed = loadWorkOrders()
            .then(loadWorkOrderOffice);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(refreshed, "Refreshing data failed"));

    }

    function onClaimWorkOrder(workOrder, employee) {
        const orderClaimed = workOrderService.patchWorkOrder(workOrder.WorkOrderID, {
            ChangeWorkOrderEmployee: {
                WorkOrderID: workOrder.WorkOrderID,
                EmployeeID: employee.Id
            }
        });

        orderClaimed.then(function () {
            // Remove the work order from the list.
            vm.workOrders = vm.workOrders.filter(function (p) {
                return p.WorkOrderID !== workOrder.WorkOrderID;
            })
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(orderClaimed, "Assigning employee failed"));
    }

    function loadWorkOrders() {
        if (!vm.icdOffice) {
            vm.workOrders = [];
            return;
        }

        return workOrderService.retrieveWorkOrders({
            HasEmployee: false,
            IcdOfficeID: vm.icdOffice.Id,
            Take: vm.pageSize,
            Skip: (vm.pageIndex - 1) * vm.pageSize
        }).then(function (workOrders) {
            workOrders.forEach(hydrateWorkOrder);
            vm.workOrders = workOrders;
        });
    }

    function hydrateWorkOrder(workOrder) {

        const statusHistory = workOrder.ProductOrders.map(function (p) {
            return p.StatusHistory;
        })
            .reduce(function (a, b) {
                return a.concat(b);
            })

        const nonBookedStatuses = statusHistory.filter(function (history) {
            return history.Status.ProductOrderStatusType !== Booked.key;
        });

        //Non-booked custom details will take priority
        const customDetailsStatus = nonBookedStatuses.length > 0 ? nonBookedStatuses.sort(function (a, b) {
            return new Date(b.EffectiveDate).getTime() - new Date(a.EffectiveDate).getTime();
        })[0]
            : statusHistory.sort(function (a, b) {
                return new Date(b.EffectiveDate).getTime() - new Date(a.EffectiveDate).getTime();
            })[0];
        workOrder.CustomDetails = JSON.parse(customDetailsStatus.CustomDetailsJson);
        workOrder.Address = !workOrder.Lead ? "" : (workOrder.Lead.Address.StreetLine1 || "") + " " + (workOrder.Lead.Address.StreetLine2 || "") + " - " + (workOrder.Lead.Address.PostalCode || "");
    }

    function loadIcdOffices() {
        return icdOfficeService.retrieveIcdOffices({ moduleID: LEADS_MODULE }) // Only show offices under the leads module.
            .then(function (icdOffices) {
                icdOffices.forEach(formatIcdOffice);
                vm.icdOffices = icdOffices.sort(function (a, b) {
                    return a.OwnerClientName < b.OwnerClientName ? -1 : 1
                });
            });
    }

    function formatIcdOffice(icdOffice) {
        icdOffice.OwnerClientName = icdOffice.OwnerName + " - " + icdOffice.IcdCorporationName;
    }

    function loadWorkOrderOffice() {
        vm.workOrders.forEach(function (workOrder) {
            workOrder.IcdOffice = vm.icdOffices.filter(function (office) {
                return office.Id === workOrder.IcdOfficeID;
            })[0];
        });
    }
}
